import { Chart } from 'chart.js';

export const valueLabelsColumn = {
  id: 'valueLabelsColumn',
  afterDatasetsDraw(chart: Chart) {
    const { ctx, data } = chart;

    const currentMonth = new Date().getMonth() + 1;

    ctx.save();

    ctx.font = '14px "Arial"';
    ctx.textAlign = 'center';

    data.datasets[2].data.forEach((value, index) => {
      const model = chart.getDatasetMeta(2).data[index];
      const x = model.x;
      const y = model.y;
      ctx.fillStyle = index < currentMonth ? '#4B5563' : 'rgba(0, 0, 0, 0.3)';
      ctx.fillText(value + '%', x, y - 5);
    });

    ctx.restore();
  },
};
